"use strict";

var _interopRequireWildcard = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/050/050admin/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var format = _interopRequireWildcard(require("@/utils/format"));
var _configOrder = require("@/api/config-order");
var _enum = require("@/utils/enum");
var _vuex = require("vuex");
var _lodash = require("lodash");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      configSystem: process.env.VUE_APP_CONFIG_SYSTEM,
      ORDER_TYPE: _enum.ORDER_TYPE,
      formData: {},
      listQuery: {},
      isLoading: false,
      loadingButton: false,
      tip: {},
      dialogStatus: "",
      dialogVisible: false,
      rules: {
        minPrice: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nội dung"
        },
        kmMinPrice: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nội dung"
        },
        pricePerKM: {
          required: true,
          trigger: "submit",
          message: "Vui lòng nội dung"
        }
      },
      tableData: []
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    areas: function areas(state) {
      return state.area.list;
    }
  })),
  watch: {
    areas: {
      immediate: true,
      deep: true,
      handler: function handler(newValue, oldValue) {
        if (newValue.length && !(0, _lodash.isEqual)(newValue, oldValue)) {
          this.$set(this.listQuery, "areaId", newValue[0].id);
          this.getData();
        }
      }
    }
  },
  created: function created() {
    this.$store.dispatch("area/fetchList");
  },
  methods: {
    formatVND: function formatVND(n) {
      return format.formatCurrency(n);
    },
    editData: function editData() {
      var _this = this;
      this.$refs["form"].validate(function (valid) {
        if (valid) {
          _this.loadingButton = true;
          var data = {
            configOrder: _this.formData
          };
          _configOrder.configOrderApi.update(_this.formData.id, data).then(function () {
            _this.$message({
              type: "success",
              message: "Cập nhật nhập thành công"
            });
            _this.dialogVisible = false;
            _this.getData();
          }).finally(function () {
            _this.loadingButton = false;
          });
        }
      });
    },
    handleEdit: function handleEdit(item) {
      this.dialogStatus = "edit";
      this.dialogVisible = true;
      this.formData = (0, _objectSpread2.default)({}, item);
    },
    getData: function getData() {
      var _this2 = this;
      this.isLoading = true;
      _configOrder.configOrderApi.findAll(this.listQuery).then(function (res) {
        if (res.data.length) {
          _this2.tableData = res.data;
        } else {
          _this2.initData();
        }
      }).finally(function () {
        _this2.isLoading = false;
      });
    },
    initData: function () {
      var _initData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _configOrder.configOrderApi.init(this.listQuery);
            case 2:
              res = _context.sent;
              this.getData();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }()
  }
};